import { useQuery, useQueryClient, useMutation } from "@tanstack/react-query";
import {
  getAlanCredentials,
  createAlanCredential,
  deleteAlanCredential,
  setDefaultAlanCredential,
} from "../Api/alanCredentials";
import { CreateAlanCredentialPayload } from "../Models/alanCredentials";

export const useAlanCredentials = () => {
  return useQuery({
    queryKey: ["alanCredentials"],
    queryFn: getAlanCredentials,
  });
};

export const useCreateAlanCredential = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: CreateAlanCredentialPayload) =>
      createAlanCredential(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["alanCredentials"] });
    },
  });
};

export const useDeleteAlanCredential = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => deleteAlanCredential(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["alanCredentials"] });
    },
  });
};

export const useSetDefaultAlanCredential = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => setDefaultAlanCredential(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["alanCredentials"] });
    },
  });
};
